export default {
  Market: "Market",
  Rates: "Rates",
  AddNew: "+ Add New",
  ThisWeek: "This week",
  PlusAddNew: "Add Coin",
};
